@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.StateStep {
  @extend %font-family-primary;

  padding: 0.5em 0.5em 0.5em 1.5em;
  color: $color-white;
  border-radius: 5px;
  display: grid;
  grid-template-columns: 1fr auto;

  svg {
    font-size: 16px;
  }

  &.Start {
    color: $color-primary-black;
    background: $color-state-initial;
  }

  &.Normal {
    background: $color-state-default;
  }

  &.Exception {
    background: $color-state-default;
  }

  &.Cleanup {
    background: $color-state-default;
  }

  &.failed {
    background: $color-warning;
  }

  &.Stateless {
    background: $color-warning-orange-hover;
    font-style: italic;
  }
}
